import { motion } from 'framer-motion'
import type { HTMLMotionProps } from 'framer-motion'
import { pageEntrance, prefersReducedMotion } from '#app/utils/animations'
import { cn } from '#app/utils/misc'

interface AnimatedContainerProps extends HTMLMotionProps<'div'> {
	children: React.ReactNode
	delay?: number
	className?: string
}

/**
 * AnimatedContainer - Wrapper component for page-level entrance animations
 * Uses Framer Motion for smooth fade + slide up entrance
 * Respects prefers-reduced-motion
 */
export function AnimatedContainer({
	children,
	delay = 0,
	className,
	...props
}: AnimatedContainerProps) {
	const shouldAnimate = !prefersReducedMotion()

	return (
		<motion.div
			initial={shouldAnimate ? 'hidden' : false}
			animate={shouldAnimate ? 'visible' : false}
			variants={pageEntrance}
			transition={{
				delay,
			}}
			className={cn(className)}
			{...props}
		>
			{children}
		</motion.div>
	)
}
